import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const DISABLE_MFA_MUTATION = gql`
  mutation DisableMfaMutation {
    disableMfa {
      disabled
      errorCode
    }
  }
`;

export default function useDisableMfa() {
  const [disableMfaMutation, { loading, error }] = useMutation(DISABLE_MFA_MUTATION, {
    noThrow: true,
  });

  const disableMfa = useCallback(async () => {
    const response = await disableMfaMutation();

    return response?.data?.disableMfa || null;
  }, [disableMfaMutation]);

  useError(error);

  return {
    disableMfa,
    loading,
  };
}
